<template>
  <header id="mainHeader" class="main-header" style="margin-bottom: -8px; margin-left: -5px">
    <!-- Top Bar -->
    <div class="top-bar bg-gray">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-4 is-hidden-sm-down" style="margin-top: -12px; width: 70% !important">
            <ul class="nav-top nav-top-left list-inline t-left">
              <li style="margin-top: 10px">
                <!--                                <a href="terms_conditions.html"><i class="fa fa-question-circle"></i>Q&A</a>-->
                <a href="?#/main">
                  <h5 style="color: #16b716">{{ $t('i18n.site_title') }}</h5>
                </a>
              </li>
              <!--                            <li><a href="faq.html color:#339933"><i class="fa fa-support"></i>Customer Assistance</a>-->
              <!--                            </li>-->
            </ul>
          </div>
          <div class="col-sm-12 col-md-8" style="width: 30% !important">
            <ul class="nav-top nav-top-right list-inline t-xs-center t-md-right d-flex" style="justify-content: flex-end">
              <li v-if="validCustomer(0)" style="margin-top: 11px; color: #717f86">{{ $t('i18n.welcome') }}，{{ username }}</li>

              <li v-if="!validCustomer(0)">
                <a href="#/login" style="color: #717f86"><i class="fa fa-lock"></i>{{ $t('i18n.login') }}</a>
              </li>
              <li>
                <a class="dropdown-item d-flex allign-items-center" href="#" style="color: #717f86" v-if="languageSelect('zh')"><i class="flag-icon flag-icon-cn"></i>简体中文</a>
                <a class="dropdown-item d-flex allign-items-center" href="#" style="color: #717f86" v-if="languageSelect('en')"><i class="flag-icon flag-icon-um"></i>English</a>
                <ul>
                  <!--                                    <li><a class="dropdown-item d-flex allign-items-center" href="#"><i class="flag-icon flag-icon-de"></i>German</a>-->
                  <!--                                    </li>-->
                  <!--                                    <li><a class="dropdown-item d-flex allign-items-center" href="#"><i class="flag-icon flag-icon-fr"></i>French</a>-->
                  <!--                                    </li>-->
                  <li>
                    <a class="dropdown-item d-flex allign-items-center" href="#" @click="selectLanguage('en')" style="color: #717f86"><i class="flag-icon flag-icon-um"></i>English</a>
                  </li>
                  <li>
                    <a class="dropdown-item d-flex allign-items-center" href="#" @click="selectLanguage('zh')" style="color: #717f86"><i class="flag-icon flag-icon-cn"></i>简体中文</a>
                  </li>
                </ul>
              </li>
              <li v-if="validCustomer(0)">
                <a href="#" @click="logoutCommand" style="color: #717f86"><i class="fa fa-user"></i>{{ $t('i18n.logout') }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- End Top Bar -->

    <!-- Header Header -->
    <div class="header-header bg-white header-background">
      <div class="container" style="width: 100%">
        <div class="row row-rl-0 row-tb-20 row-md-cell">
          <div class="brand col-md-3 t-xs-center t-md-left valign-middle" style="width: 10%">
            <a href="?#/main" class="logo">
              <img src="@/assets/img/Cint400_276.png" style="margin-left: -110px" />
            </a>
          </div>
          <div class="header-search col-md-9" style="padding-bottom: 10px; width: 60%">
            <div class="row row-tb-10">
              <div class="col-sm-8" style="width: 100%; float: right; padding-top: 20px" v-if="validCustomer(1)">
                <div class="input-group" style="width: 94%">
                  <input
                    type="text"
                    v-model="filters.words"
                    @change="handleSearch"
                    class="form-control input-lg search-input"
                    :placeholder="$t('i18n.please_input_keywords')"
                    required="required"
                    style="border-right: 0px; background-color: #fff !important; border: 1px !important"
                  />
                  <div class="input-group-btn" @click="handleSearch">
                    <div class="input-group">
                      <div class="input-group-btn">
                        <button type="submit" class="btn btn-lg btn-search btn-block">
                          <i class="fa fa-search font-16"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-group" style="width: 98%; margin-top: 8px">
                  <table>
                    <tr>
                      <td>
                        <el-select v-model="filters.agency_ids" @change="optionChange" filterable clearable :placeholder="$t('i18n.please_select_agency')" style="width: 200px; border: 0px">
                          <el-option v-for="agency in agencies" :key="agency.agency_id" :label="agency.name" :value="agency.agency_id"> </el-option> </el-select
                        >&nbsp;
                      </td>
                      <td>
                        <el-select v-model="filters.area_ids" @change="optionChange" filterable clearable :placeholder="$t('i18n.please_select_area')" style="width: 160px; border: 0px">
                          <el-option v-for="area in areas" :key="area.area_id" :label="area.name" :value="area.area_id"> </el-option> </el-select
                        >&nbsp;
                      </td>
                      <td>
                        <el-select v-model="filters.industry_id" @change="optionChange" filterable clearable :placeholder="$t('i18n.please_select_industry')" style="width: 160px; border: 0px">
                          <el-option v-for="area in industrys" :key="area.industry_id" :label="area.name" :value="area.industry_id"> </el-option> </el-select
                        >&nbsp;
                      </td>
                      <td>
                        <el-date-picker
                          v-model="filters.publish_date"
                          @change="optionChange"
                          @focus="publishDateDefault"
                          type="monthrange"
                          range-separator=""
                          :start-placeholder="$t('i18n.start_month')"
                          :end-placeholder="$t('i18n.end_month')"
                          style="width: 210px; height: 36px; border: 1px solid #ddd; border-radius: 3px"
                        >
                        </el-date-picker>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Header Header -->

    <!-- Header Menu -->
    <div class="header-menu bg-blue">
      <div class="container">
        <nav class="nav-bar"></nav>
      </div>
    </div>
    <!-- End Header Menu -->
  </header>
</template>
<script>
import bus from '../common/bus'
import util from '../../common/js/util'
import { getAgencyList } from '../../api/api'
import { getAreaList, getIndustryList } from '../../api/api'
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      collapse: false,
      agencies: [],
      areas: [],
      industrys: [],
      filters: {
        words: '',
        publish_date: [],
        industry_id: ''
      },
      language: 'zh'
    }
  },
  computed: {
    username() {
      let username = localStorage.getItem('carbon_emission_user_name')
      return username ? username : this.name
    }
  },
  watch: {
    $route(newValue, oldValue) {
      window.location.reload()
    }
  },
  methods: {
    selectLanguage(lan) {
      localStorage.setItem('carbon_emission_language', lan)
      window.location.reload()
    },
    languageSelect(lan) {
      return this.language == lan ? true : false
    },
    logoutCommand() {
      localStorage.removeItem('carbon_emission_token')
      localStorage.removeItem('carbon_emission_user_id')
      localStorage.removeItem('carbon_emission_user_name')
      localStorage.setItem('carbon_emission_logout', 1)
      this.filters.words = ''
      this.publish_date = []
      location.reload()
    },
    validCustomer(info) {
      let token = localStorage.getItem('carbon_emission_token')
      let path = this.$route.path
      if (token && token.length > 0) {
        return true
      } else if (info && this.$route.path == '/main') {
        return true
      } else {
        return false
      }
    },
    notReport() {
      let report_id = util.getQueryStringByName('report_id')
      if (report_id) {
        return false
      } else {
        return true
      }
    },
    getAgencies() {
      let para = {
        limit: 100
      }
      getAgencyList(para).then(res => {
        this.total = parseInt(res.data.data.total_num)
        this.agencies = res.data.data.agencies
      })
    },
    getAreas() {
      let para = {
        limit: 100
      }
      getAreaList(para).then(res => {
        this.total = parseInt(res.data.data.total_num)
        this.areas = res.data.data.areas
      })
      getIndustryList(para).then(res => {
        this.total = parseInt(res.data.data.total_num)
        this.industrys = res.data.data.areas
      })
    },
    publishDateDefault: function () {
      if (this.filters.publish_date == undefined || this.filters.publish_date.length == 0) {
        this.filters.publish_date = [util.getLastYearYestady(), new Date()]
      }
    },
    handleSearch: function () {
      if (this.filters.words.length > 0) {
        window.location = '?query=' + JSON.stringify(this.filters)
      }
    },
    optionChange: function (row) {
      window.location = '?query=' + JSON.stringify(this.filters)
    }
  },
  mounted() {
    if (localStorage.getItem('carbon_emission_language')) {
      this.language = localStorage.getItem('carbon_emission_language')
    }
    this.getAgencies()
    this.getAreas()
    let query = util.getQueryStringByName('query')
    if (query && query.length > 0) {
      this.filters = JSON.parse(decodeURI(query))
    }
    if (!localStorage.getItem('carbon_emission_token')) {
      this.filters.words = ''
    }
    // localStorage.removeItem('carbon_emission_token')
    // localStorage.removeItem('carbon_emission_user_id')
    // localStorage.removeItem('carbon_emission_user_name')
    // localStorage.setItem('carbon_emission_logout', 1)
  }
}
</script>
<style scoped>
  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
  }
  .collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
  }
  .header .logo {
    float: left;
    width: 250px;
    line-height: 70px;
  }
  .header-right {
    float: right;
    padding-right: 50px;
  }
  .header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
  }
  .btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
  }
  .btn-bell,
  .btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
  }
  .btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
  }
  .btn-bell .el-icon-bell {
    color: #fff;
  }
  .user-name {
    margin-left: 10px;
  }
  .user-avator {
    margin-left: 20px;
  }
  .user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .el-dropdown-link {
    color: #fff;
    cursor: pointer;
  }
  .el-dropdown-menu__item {
    text-align: center;
  }
  .header-background {
    position: relative;
    width: 100%;
    height: 170px;
    background-image: url(../../assets/img/header-background.jpg);
    background-size: 100%;
    background-repeat: no-repeat;
    display: inline-block;
    margin-left: 5px !important;
  }
</style>
